import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import EmptyState from './components/EmptyState.vue';
import i18nPlugin, { i18n } from './i18n';

axios.interceptors.request.use((reqConfig) => {
  const activeLocale = i18n.locale || localStorage.getItem('gamiteam_locale') || 'id';
  reqConfig.headers = reqConfig.headers || {};
  reqConfig.headers['Accept-Language'] = activeLocale;
  return reqConfig;
});

if (typeof document !== 'undefined' && document.documentElement) {
  document.documentElement.setAttribute('lang', i18n.locale || 'id');
}

Vue.use(i18nPlugin);
Vue.component('EmptyState', EmptyState);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
